import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, provideConfig } from 'haba-core';
import { CartPageLayoutHandler, PAGE_LAYOUT_HANDLER } from 'haba-storefrontlib';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: CartPageLayoutHandler,
      multi: true,
    },
    provideConfig(<CmsConfig>{
      featureModules: {
        CartCustomModule: {
          module: () => import('./cart-custom.module').then((m) => m.CartCustomModule),
          cmsComponents: [
            'EmptyCartComponent',
            'CartTitleComponent',
            'CartTotalsComponent',
            'CartApplyCouponComponent',
            'CartComponent',
            'ProductAddToCartComponent',
            'CartBottomComponent',
          ],
        },
      },
    }),
  ],
})
export class CartFeatureModule {}
